import React from "react";
import { Link } from "react-router-dom";
import { Checkbox } from "@/components/ui/checkbox";

export default function TermsConsent({ checked, onChange, testId = "terms-consent", variant = "chef" }) {
  const points = variant === "catering"
    ? [
        "Final quote is confirmed by our team against your brief before execution.",
        "Chefs and service staff are on Chef Hire's payroll and report to Chef Hire.",
        "Anything added outside the agreed brief on the day is chargeable.",
        "Guest count changes must be confirmed 48 hours before the event.",
        "Cancellation within 48 hours of the event is chargeable.",
      ]
    : [
        "One-time fee of one month's salary + 18% GST. No percentage commission.",
        "Staff are on Chef Hire's payroll and report to Chef Hire.",
        "Trials ₹2,500–₹5,000/day, booked 2 days in advance.",
        "Replacement of equal calibre within 1 week, with a standby chef meanwhile.",
        "Work outside the agreed brief is chargeable. 11-month renewable agreement.",
      ];
  return (
    <div className="border border-white/10 bg-[#141414] p-4">
      <div className="small-caps text-[10px] text-neutral-500 mb-3">Key terms</div>
      <ul className="text-[11px] text-neutral-400 space-y-1.5 leading-relaxed list-disc pl-4">
        {points.map((p) => <li key={p}>{p}</li>)}
      </ul>
      <label className="flex items-start gap-3 mt-4 cursor-pointer">
        <Checkbox checked={checked} onCheckedChange={(v) => onChange(!!v)} data-testid={testId}
          className="rounded-none border-white/30 data-[state=checked]:bg-[#C04000] data-[state=checked]:border-[#C04000] mt-0.5" />
        <span className="text-xs text-neutral-300">
          I have read and accept the{" "}
          <Link to="/terms" target="_blank" className="text-[#F5B041] hover:underline" data-testid={`${testId}-link`}>
            Terms &amp; Conditions
          </Link>.
        </span>
      </label>
    </div>
  );
}
